module.exports = __webpack_public_path__ + "static/media/ccp.adca7914.jpg";